export const meta = {
  id: 'boyer-moore',
  name: 'Boyer-Moore Algorithm',
  category: 'Strings',
  complexity: {
    time: 'O(n)',
    space: 'O(m)'
  },
  description: 'Boyer-Moore string search algorithm. Skips sections of text using bad character and good suffix heuristics for efficient pattern matching.'
};
